import acctService from './../../../services/account';

export default {
  data() {
    return {
      email: '',
      emailSent: false,
      doingSomething: false,
      errmsg: '',
    };
  },
  mounted() {
    this.doingSomething = false;
  },
  methods: {
    resetpw() {
      if (!this.email || this.email == '') {
        this.errmsg = 'You must supply an email address';
        return;
      }
      this.errmsg = '';
      this.doingSomething = true;
      const vm = this;
      const clearErrMsg = function clearErrMsg() { vm.doingSomething = false; vm.errmsg = ''; };
      const cbSuccess = function cbSuccess(response) {
        vm.doingSomething = false;
        vm.emailSent = true;
        vm.errmsg = '';
      };
      const cbFail = function cbFail(response) {
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error resetting password - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error resetting password - Please try again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      acctService.resetpwemail(this.email, cbOptions);
    },
  },
  components: {
    VLayout: require('layouts/minimal/minimal.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/user/resetpwblind/index.js